
import { Options, Vue } from "vue-class-component";

import { CoreService } from "./services";

@Options({})
export default class App extends Vue {
  public background = document.createElement("video");
  public source = document.createElement("video");
  public backgrounds: string[] = Array.from(new Array(7), (_, i: number) =>
    require(`@/assets/background_${i + 1}.mp4`)
  );

  public $refs!: {
    canvas: HTMLCanvasElement;
  };

  public onUploadBackground(event: any): void {
    this.background.src = URL.createObjectURL(event.target.files[0]);
  }

  public async mounted(): Promise<void> {
    this.background.crossOrigin = "Anonymous";
    this.background.autoplay = true;
    this.background.loop = true;

    await new CoreService(
      this.$refs.canvas,
      this.source,
      this.background
    ).setOptions({
      selfieMode: true,
      modelSelection: 1,
    });
  }
}
